<template>
<div v-if="realLoading" class="loading-container">
  <div class="loading-content">
    <v-progress-circular indeterminate v-bind:size="50" class="primary--text"></v-progress-circular>
  </div>
</div>
</template>

<script>
/**
 * Crea un overlay di caricamento
 * @module components/common/Loading
 */
export default {
  name: 'loading',
  data () {
    return {
      realLoading: false
    }
  },
  props: ['loading'],
  watch: {
    loading (newLoading, oldLoading) {
      if(oldLoading && !newLoading){
        setTimeout(() => {
          this.realLoading = newLoading
        }, 500)
      }else{
        this.realLoading = newLoading
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/Loading.vue